import { Tag as BaseTag } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import colors from 'config/theme/colors';
import { SIGNATURE_STATUS } from 'constants/Global';
import { createDictionary } from 'utils/ObjectUtils';

import { tagPillStyle } from './UI';

type SignatureStyle = {
  color: string;
  background: string;
  label: React.ReactNode;
}

export const SIGNATURE_STATUS_STYLE = createDictionary<SignatureStyle, SignatureStyle>(
  {
    [SIGNATURE_STATUS.SIGNED]: {
      label: <FormattedMessage id="signature.statusTag.signed" defaultMessage="Signed" />,
      background: colors['@success-color-light'],
      color: colors['@success-color-dark'],
    },
  },
  {
    label: <FormattedMessage id="signature.statusTag.unsigned" defaultMessage="Waiting for signature" />,
    background: colors['@yellow-light-tarnished'],
    color: colors['@text-color'],
  }
);

type TagProps = {
  status: keyof typeof SIGNATURE_STATUS
};

const Tag: React.FC<TagProps> = ({ status }) => (
  <BaseTag
    variant="solid"
    data-cy="signature-tag"
    style={{ color: SIGNATURE_STATUS_STYLE[status].color }}
    color={SIGNATURE_STATUS_STYLE[status].background}
    className={classNames(tagPillStyle, 'rounded-pill ml-3 font-weight-medium')}
  >
    {SIGNATURE_STATUS_STYLE[status].label}
  </BaseTag>
);

export default Tag;
